/* Compare: checkbox wiring. Buttons carry data-compare="<handle>".
   Delegated, so it works on grids that paginate or filter in place. */
(function () {
  function paint() {
    var els = document.querySelectorAll('[data-compare]');
    var full = window.croCompare.read().length >= window.croCompare.MAX;
    for (var i = 0; i < els.length; i++) {
      var on = window.croCompare.has(els[i].getAttribute('data-compare'));
      els[i].setAttribute('aria-pressed', on ? 'true' : 'false');
      els[i].classList.toggle('is-on', on);
      els[i].disabled = !on && full;
    }
  }

  document.addEventListener('click', function (e) {
    var b = e.target.closest('[data-compare]');
    if (!b) return;
    e.preventDefault();
    var r = window.croCompare.toggle(b.getAttribute('data-compare'));
    if (r === null) return;
    paint();
  }, true);

  document.addEventListener('compare:changed', paint);
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', paint);
  } else { paint(); }
})();
